
import Vue from 'vue'

export default Vue.extend({
  name: "UiCard",
  props: {
    padding: Number,
    theme: String
  }
})
